// The two views of the production plan screen: the loom Gantt and the availability calendar.
export enum ProductionPlanViews {
  plan = 'plan',
  availability = 'availability',
}
